import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { isAfter, subDays } from 'date-fns';

export const isNewSitterResume = (data: CatalogItemViewModel) => {
  return (
    data.type === CatalogItemType.Resume,
    (data.careerId as CareerId) === CareerId.Nanny &&
      data.clientProfile?.createdAt &&
      isAfter(new Date(data.clientProfile.createdAt), subDays(new Date(), 14))
  );
};
